import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search--sprite",
  "use": "search--sprite-usage",
  "viewBox": "0 0 29 30",
  "content": "<symbol viewBox=\"0 0 29 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"search--sprite\">\n<circle cx=\"12.9231\" cy=\"12.9231\" r=\"10.9231\" stroke-width=\"4\" />\n<path d=\"M20.4609 21.5391L26.9225 28.0006\" stroke-width=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol